import React, { Component, PropTypes } from 'react';
import { uniqueId } from 'lodash';
import classNames from 'classnames';
import { CargoType } from 'types';
import { translate as t } from 'lang';

import CargosStore from 'stores/CargosStore';
import ActionCreators from 'actions/ActionCreators';

import CargosInfo from 'components/CargosInfo';
import IconSVG from 'svg-inline-react';
import CheckboxControl from 'components/CheckboxControl';
import CounterControl from 'components/CounterControl';
import SuggestControl from 'components/SuggestControl';
import SubcategoriesConstants from '../../../constants/Subcategories';
import ButtonControl from 'components/ButtonControl';
import { cancelablePromise } from 'core/utils';
import { getCargoNames } from 'api';

var getCargoNamesPromise = null;
const searchIcon = <IconSVG className="cargos-filter-search__icon" src={require('!svg-inline!./search.svg')}/>;

class Subcategories extends Component {

    static propTypes = {
        cargos       : PropTypes.arrayOf(CargoType).isRequired,
        onAddCargo   : PropTypes.func,
        onAddNewCargo: PropTypes.func,
        onRemoveCargo: PropTypes.func,
        toAllCargos  : PropTypes.func
    }

    state = {
        suggestions: [],
        searchCargoFocused: false,
        selectedSubcategoryId: SubcategoriesConstants.MOVING_ID,
        searchString: '',
    }

    componentWillMount() {
        if (this.props.movingQueryType === 'office') {
            this.setState({
                selectedSubcategoryId: SubcategoriesConstants.OFFICE_MOVING_ID,
            });
        }
    }

    componentWillUnmount() {
        this.cancelGetCargoNames();
    }

    cancelGetCargoNames() {
        getCargoNamesPromise && typeof getCargoNamesPromise.cancel === 'function' ? getCargoNamesPromise.cancel() : false;
    }

    /**
     * @param {CargoType} cargo "Конечный" груз
     * @return {object}
     */
    renderCargo = (cargo, index) => {
        var countControl;
        var cargoType = CargosStore.getDeliveryCargo(cargo.id);
        var cargoName = cargo.name;
        var cargoProps = {
            key: index,
            className: classNames(
                "cargos-item",
                {"cargos-item--added": cargoType}
            ),
            onClick: this.handlerAddCargoClick.bind(this, cargo.id, cargoName, cargo.stuff_type_id)
        };
        var addControl = (
            <div className="cargos-item__add-control">
                <CheckboxControl
                    stopClickCheckboxPropagation={true}
                    value={ Boolean(cargoType) }
                    onClick={ this.handlerAddCargoCheckboxClick.bind(this, cargo.id, cargoName, cargo.stuff_type_id) }/>
            </div>
        );

        if (cargoType) {
            let cargoIndex = 0;

            CargosStore.getDeliveryCargos().toJS().forEach((item, index) => {
                if (item.id === cargo.id) {
                    cargoIndex = index;
                }
            });

            countControl = (
                <div className="cargos-item__count-control">
                    <IconSVG className="cargos-item__edit"
                             src={require('!svg-inline!./pen.svg')}
                             title="Отредактировать груз"
                             onClick={this.handlerEditCargo.bind(this, cargoType, cargoIndex)}
                         />
                    <CounterControl
                        value={ cargoType.getIn(['attributes', 'quantity', 'value'], 1) }
                        minValue={1}
                        onChange={this.handlerCargoQuantityChange.bind(this, cargo.id, cargoType)} />
                </div>
            );
        }

        return (
            <div {...cargoProps}>
                <div className="cargos-item-name" dangerouslySetInnerHTML={{ __html: cargoName }}/>
                { countControl }
                { addControl }
            </div>
        );
    }

    renderSubcategoryCargos = (type) => {

        var classes = ["cargos-" + type];
        var ref = "cargosList" + type;
        var noCargos = null;
        var list = null;
        var addCargoButton = null;

        var subcategoryCargos = CargosStore.getSubcategoryCargos(this.state.selectedSubcategoryId);
        var deliveryCargos = CargosStore.getDeliveryCargos().toJS().reverse();

        deliveryCargos = deliveryCargos.filter(deliveryCargo => {
            var find = subcategoryCargos.find(subcategoryCargo => {
                if (deliveryCargo.id === subcategoryCargo.id) {
                    subcategoryCargo.name = deliveryCargo.name;
                    return true;
                }
            });

            return find === undefined;
        });

        var cargos = deliveryCargos.concat(subcategoryCargos);

        if (this.state.searchString) {
            addCargoButton = (
                <ButtonControl view="forest"
                               size="s"
                               onClick={this.handlerFilterAddCargoButtonClick}>
                    {t('ADD_TO_LIST')}
                </ButtonControl>
            );
        }

        if ( (cargos.length === 0 && !this.state.searchString) || !this.state.selectedSubcategoryId ) {
            noCargos = (
                <div className="cargos-list-empty" dangerouslySetInnerHTML={{__html: t('SELECT_CATEGORY') }}/>
            );
        } else {
            list = cargos.map((cargo, index) => {
                return this.renderCargo(cargo, index);
            });
        }

        var cargosFilterDesktopClasses = classNames(
            'cargos-filter-desktop', {
                'cargos-filter-desktop--focused': this.state.searchCargoFocused ? true : false
            });

        return (
            <div className={ classes.join(' ') }>
                <div className={cargosFilterDesktopClasses}>
                    <div className="cargos-filter-search">
                        {searchIcon}
                    </div>
                    <SuggestControl
                        suggestions={this.state.suggestions}
                        onSuggestionsFetchRequested={this.handlerGetNameSuggestions}
                        renderSuggestion={this.handlerSuggestionRenderer}
                        getSuggestionValue={this.handlerSuggestionValue}
                        onSuggestionsClearRequested={this.handleSuggestionClearRequested}
                        inputProps={{
                            inputRef: 'input',
							placeholder: t('TYPE_STUFF_NAME_HERE'),
							onChange: this.handlerSearchChange,
							onFocus: this.handlerSearchFocus,
							onBlur: this.handlerSearchBlur,
                            value: this.state.searchString || '',
						}}
                        focusInputOnSuggestionClick={true}
                        onSuggestionSelected={this.handlerNameSuggestionSelected} />
                    <div className="cargos-filter-add-button">
                        { addCargoButton }
                    </div>
                </div>
                <div className="cargos-list-or-add-your-text">Или быстро добавьте груз из нашего списка популярных грузов ниже:</div>
                <div ref={ ref } className="cargos-list">
                    { noCargos }
                    <div className="cargos-list-mobile-addcargo">
                        {addCargoButton}
                    </div>
                    { list }
                </div>
                <div onClick={this.handlerFilterAddCargoButtonClick} className="cargos-item cargos-item-add-cargo-block">
                    <ButtonControl
                        className="cargos-item-add-button"
                        view="blueLink"
                        size="s"
                        onClick={this.handlerFilterAddCargoButtonClick}>
                        <span className="cargos-item-add-button-icon">+</span>&nbsp;<span className="cargos-item-add-button-text">Добавить свой груз</span>
                    </ButtonControl>
                </div>
            </div>
        );
    }
    
    renderList = () => {
        const search = (
            <div className="cargos-filter-mobile">
                <div className="cargos-filter-search">
                    {searchIcon}
                </div>
                <SuggestControl
                    suggestions={this.state.suggestions}
                    onSuggestionsFetchRequested={this.handlerGetNameSuggestions}
                    renderSuggestion={this.handlerSuggestionRenderer}
                    getSuggestionValue={this.handlerSuggestionValue}
                    onSuggestionsClearRequested={this.handleSuggestionClearRequested}
                    inputProps={{
                        inputRef: 'input',
                        placeholder: t('TYPE_STUFF_NAME_HERE'),
                        onChange: this.handlerSearchChange,
                        onFocus: this.handlerSearchFocus,
                        onBlur: this.handlerSearchBlur,
                        value: this.state.searchString || '',
                    }}
                    focusInputOnSuggestionClick={true}
                    onSuggestionSelected={this.handlerNameSuggestionSelected} />
            </div>
        )
    
        const cargos = this.renderSubcategoryCargos("mobile")
        
        return (
            <div className="list">
                <div className="list-item">
                    { search }
                    { cargos }
                </div>
                <CargosInfo cargos={CargosStore.getDeliveryCargos()} toAllCargos={this.handlerToAllCargos}/>
            </div>
        );
    }

    handlerEditCargo(cargo, cargoIndex) {
        ActionCreators.startCargoEditing(cargo, cargoIndex);
    }

    handlerSubcategoryClick = (stuffTypeId, event) => {
        var itemId = stuffTypeId;
        if (stuffTypeId === this.state.selectedSubcategoryId) {
            itemId = 0;
        }

        this.cancelGetCargoNames();

        this.setState({
            selectedSubcategoryId: itemId,
            searchString: '',
        });
    }

    handlerAddCargoClick = (cargoId, cargoName, stuffTypeId, event) => {
        var addCargo = !Boolean(CargosStore.getDeliveryCargo(cargoId));

        if (addCargo) {
            if (this.props.onAddCargo) this.props.onAddCargo(cargoId, stuffTypeId, cargoName);
        }
    }

    handlerAddCargoCheckboxClick = (cargoId, cargoName, stuffTypeId, event) => {
        var addCargo = !Boolean(CargosStore.getDeliveryCargo(cargoId));

        if (addCargo) { // Add cargo
            if (this.props.onAddCargo) this.props.onAddCargo(cargoId, stuffTypeId, cargoName);
        } else { // Remove cargo
            if (this.props.onRemoveCargo) this.props.onRemoveCargo(event, cargoId);
        }
    }

    handlerCargoQuantityChange = (cargoId, cargoType, event, nextValue) => {
        ActionCreators.updateDeliveryCargo({
            cargoId: cargoId,
            key    : 'quantity',
            value  : nextValue
        });

        let weight = cargoType.getIn(['attributes', 'weight', 'value']) || 0;
        let volume = cargoType.getIn(['attributes', 'volume', 'value']) || 0;

        volume /= 1000000; // => m3

        weight = Math.round(weight * 100) / 100; // toFixed(2 or less)
        volume = Math.round(volume * 100) / 100; // toFixed(2 or less)

        let totalWeight = CargosStore.getTotalMeasurements().get('total_weight');
        let totalVolume = CargosStore.getTotalMeasurements().get('total_volume');

        const prevValue = cargoType.getIn(['attributes', 'quantity', 'value']);

        if (nextValue > prevValue) {
            for (let i = 0; i < nextValue - prevValue; i++) {
                totalWeight += weight;
                totalVolume += volume;
            }
        } else {
            for (let i = 0; i < prevValue - nextValue; i++) {
                totalWeight -= weight;
                totalVolume -= volume;
            }
        }

        ActionCreators.setTotalMeasurements(totalWeight, totalVolume);
    }

    handlerSearchChange = (event, data) => {
        this.setState({
            searchString: data.newValue,
        });
    }

    handlerSearchFocus = () => {
        this.setState({
            searchCargoFocused: true,
        });
    }

    handlerSearchBlur = () => {
        this.setState({
            searchCargoFocused: false,
        });
    }

    handlerToAllCargos = (e) => {
        if (this.props.toAllCargos) this.props.toAllCargos(e);
    }

    handlerFilterAddCargoButtonClick = () => {

        var cargo = CargosStore.getCargoByStuffTypeId(this.state.selectedSubcategoryId);
        cargo = cargo.withMutations(cargo => {
            cargo.set('name', this.state.searchString);

            // This cargo is unknown for our system, but id is needed to identify it
            // for removing, updating and other logic to work properly.
            cargo.set('id', -1 * uniqueId());

            var name = cargo.getIn(['attributes', 'name', 'value'], '');
            if (!name) {
                cargo.setIn(['attributes', 'name', 'value'], this.state.searchString);
            }
        });

        if (this.props.onAddNewCargo) {

            this.setState({
                searchString: '',
            });

            this.cancelGetCargoNames();

            this.props.onAddNewCargo(cargo, false);
        }
    }

    handlerGetNameSuggestions = (query) => {
        query = query.value;
        getCargoNamesPromise = cancelablePromise(getCargoNames(query));

        return getCargoNamesPromise
            .promise
            .then(data => {
                let suggestions = [];

                if (Object.keys(data.response).length > 0) {
                    for (let id in data.response) {
                        if (!data.response.hasOwnProperty(id)) continue;

                        let suggestion = data.response[id];
                        suggestions.push({
                            ...suggestion,
                            value: suggestion.name,
                            data: suggestion,
                        });
                    }
                } else {
                    suggestions.push({
                        value: t('THIS_IS_NEW_STUFF_FOR_US'),
                    });
                }

                if (suggestions.length > 0) {
                    this.setState({suggestions});
                }

                return suggestions;
        }).catch(error => {});
    }

    handlerSuggestionRenderer = (suggestion) => {
        if (!suggestion) {
            return '';
        }

        return suggestion.value;
    }

    handlerSuggestionValue = (suggestion) => {
        if (!suggestion) {
            return '';
        }

        return suggestion.value;
    }

    handleSuggestionClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    }

    handlerNameSuggestionSelected = (event, { suggestion }) => {
        if (!suggestion || !suggestion.data) {
            this.handlerFilterAddCargoButtonClick();
            return false;
        }

        let cargo = CargosStore.createCargoType(suggestion);
        const name = cargo.getIn(['attributes', 'name', 'value'], '');

        if (!name) {
            cargo = cargo.setIn(['attributes', 'name', 'value'], suggestion.name);
        }

        const inDelivery = CargosStore.getDeliveryCargos().find(deliveryCargo => {
            return suggestion.id === deliveryCargo.id;
        });

        if (this.props.onAddCargo && !inDelivery) {
            this.setState({
                searchString: '',
            });

            this.props.onAddCargo(suggestion.id, suggestion.stuff_type_id, suggestion.name, suggestion.attributes);
        }
    }

    render() {
        return (
            <div className="subcategories">
                { this.renderList() }
                { this.renderSubcategoryCargos("desktop") }
                <div className="subcategories__end"></div>
            </div>
        );
    }
}

export default Subcategories;



// WEBPACK FOOTER //
// ./client/components/Categories/Moving/Subcategories.js